import { render } from "./message.vue?vue&type=template&id=6fea76d6&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"

import "./message.vue?vue&type=style&index=0&id=6fea76d6&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fea76d6"]])

export default __exports__